import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Какие форматы документов поддерживает ScanMind?',
  answer: 'Платформа поддерживает PDF (включая сканированные), TIFF, JPEG, PNG и другие растровые форматы. Мы также работаем с многостраничными документами и архивами ZIP с автоматической распаковкой.'
}, {
  question: 'Нужна ли разработка для интеграции с нашими системами?',
  answer: 'Нет. ScanMind предоставляет готовый REST API с подробной документацией и SDK для Python, Java и Node.js. Большинство клиентов подключаются за 1–3 дня без привлечения разработчиков.'
}, {
  question: 'Можно ли развернуть платформу на наших серверах?',
  answer: 'Да. Мы предлагаем три модели развёртывания: облако ScanMind, ваш частный контур (on-premise) и гибридный вариант. Для on-premise поставляется Docker-образ с полной документацией.'
}, {
  question: 'Какая точность распознавания у OCR?',
  answer: 'На печатном тексте — до 99,9%. На рукописном — до 97% в зависимости от качества скана. Модели можно дообучить на ваших типах документов для повышения точности.'
}, {
  question: 'Как обеспечивается безопасность данных?',
  answer: 'Платформа соответствует SOC2 Type II. Все данные шифруются при передаче (TLS 1.3) и хранении (AES-256). Поддерживается ролевой доступ, аудит-логи и интеграция с корпоративным SSO.'
}, {
  question: 'Есть ли бесплатный пробный период?',
  answer: 'Да, мы предоставляем 14-дневный пробный доступ с лимитом 1 000 страниц. Для крупных проектов доступна расширенная пилотная программа — свяжитесь с нами для деталей.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 bg-white border-t border-gray-200" data-id="element-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="text-center mb-14" data-id="element-22">
          <p className="text-sm font-semibold text-blue-900 uppercase tracking-wider mb-3" data-id="element-23">
            FAQ
          </p>
          <h2 className="text-3xl md:text-4xl font-sans font-bold text-gray-900" data-id="element-24">
            Частые вопросы
          </h2>
        </div>

        <div className="divide-y divide-gray-200" data-id="element-25">
          {faqs.map((faq, index) => <div key={index} data-id="element-26">
              <button onClick={() => toggle(index)} className="w-full flex items-start justify-between gap-4 py-6 text-left group" data-id="element-27">
                <span className="text-base font-medium text-gray-900 group-hover:text-blue-900 transition-colors" data-id="element-28">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5 transition-transform duration-200 ${openIndex === index ? 'rotate-180 text-blue-900' : ''}`} data-id="element-29" />
              </button>
              <div className={`overflow-hidden transition-all duration-200 ${openIndex === index ? 'max-h-60 pb-6' : 'max-h-0'}`} data-id="element-30">
                <p className="text-gray-500 leading-relaxed text-sm pr-10" data-id="element-31">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}